import { Campaign, CampaignType } from './Campaign';
import { SimpleAsset } from './Asset';

export class FormatBuildModel {
    env: string;
    campaignType: CampaignType;
    creativeCode: string;
    clickUrl: string;
    buildConfiguration: BuildConfiguration;
    assets: SimpleAsset[];
    letterbox?: string;
    parentGuid?: string;
    parentCampaignType?: string;
    parentHeight?: TopscrollHeightEnum;
    interactionEnabled?: string;

    constructor(_env: string, _campaigntype: CampaignType, _creativecode: string, _clickurl: string, _assets: SimpleAsset[], _buildconfiguration: BuildConfiguration, _bannerConfiguration: BannerConfiguration) {
        this.env = _env;
        this.campaignType = _campaigntype;
        this.creativeCode = _creativecode;
        this.clickUrl = _clickurl;
        this.buildConfiguration = _buildconfiguration;
        this.assets = _assets;
    }
}

export class BannerConfiguration {
    javascript?: string;
    html?: string;
    css?: string;

    constructor(javascript?: string, html?: string, css?: string) {
        this.javascript = 'js';
        this.html = 'html';
        this.css = 'css';
    }
}
export class BuildConfiguration {
    configuration?: Configuration;
    thirdPartyTags?: ThirdPartyTag[];

    //For Sideskin
    leftCreativeCode?: string;
    rightCreativeCode?: string;

    //For InreadExpander
    micrositeUrl?: string;

    //For Html topscroll/interscroll && Video topscroll/interscroll
    htmlCreativeCode?: string;

    //For the simple video template
    letterbox?: string;

    //FOR HTML TOPSCROLL
    interactionEnabled?: string;

    constructor()
    constructor(type: CampaignType, conf: BuildConfiguration)
    constructor(type?: CampaignType, conf?: BuildConfiguration) {
        this.thirdPartyTags = [];
        this.configuration = new Configuration(type); //Populate default configuration obtions based on type

        if (conf) {
            var mergedConf = Object.assign(this.configuration, conf.configuration);
            Object.assign(this, conf);
            this.configuration = mergedConf;
        }
    }
}

export class ThirdPartyTag {
    type: ThirdPartyTagType;
    tag: string;
}

export enum ThirdPartyTagType {
    Banner = 1,

    //For Html Interscroll & Html Topscroll
    Html_Banner = 10,

    ImpressionTrackingPixel = 20,
    TrackingScript = 30,

    //For Sideskin sides
    Sideskin_LeftBanner = 40,
    Sideskin_RightBanner = 50,
}

export const ThirdPartyTagLabel = new Map<ThirdPartyTagType, string>([
    [ThirdPartyTagType.Banner, 'Top banner tag'],
    [ThirdPartyTagType.ImpressionTrackingPixel, 'Impression tracking pixel'],
    [ThirdPartyTagType.TrackingScript, 'Tracking script'],
    [ThirdPartyTagType.Sideskin_LeftBanner, 'Side skin left banner tag'],
    [ThirdPartyTagType.Sideskin_RightBanner, 'Side skin right banner tag'],
    [ThirdPartyTagType.Html_Banner, 'HTML banner tag']
]);

export class Configuration {
    //For Topscroll
    topscrollHeight: TopscrollHeightEnum;
    relativeHeight: RelativeHeightEnum;

    //For Skin, Sideskin, Interscrollers
    height: number;
    width: number;

    //FOR VIDEO TEMPLATE
    letterbox?: string;

    //FOR HTML TOPSCROLL
    interactionEnabled?: string;

    //FOR BANNERHOSTING
    html?: string;
    javascript?: string;
    css?: string;

    constructor()
    constructor(type: CampaignType)
    constructor(type?: CampaignType) {
        if (type) {
            switch (type) {
                case CampaignType.topscroll:
                case CampaignType.topscroll_desktop_image:
                    this.topscrollHeight = TopscrollHeightEnum["80%"];
                    this.letterbox = "true";
                    break;
                case CampaignType.html_topscroll:
                case CampaignType.topscroll_desktop_html:
                case CampaignType.video_topscroll:
                case CampaignType.topscroll_desktop_video:
                    this.interactionEnabled = "false";
                    this.topscrollHeight = TopscrollHeightEnum["80%"];
                    this.letterbox = "true";
                    break;
                case CampaignType.skin:
                case CampaignType.sideskin:
                case CampaignType.video_skin:
                    this.height = 180;
                    this.width = 930;
                    break;
                case CampaignType.desktop_interscroll:
                    this.height = 600;
                    this.width = 930;
                    break;
                case CampaignType.desktop_fullscreen_interscroll:
                    this.height = 600;
                    break;
                case CampaignType.html_interscroll:
                    this.height = 480;
                    this.interactionEnabled = "false";
                    break;
                case CampaignType.mobil_interscroll:
                    this.height = 480;
                    break;
                case CampaignType.vertical_video_interscroll:
                    this.height = 600;
                    this.interactionEnabled = "false";
                    break;
                case CampaignType.video_banner_template:
                    this.letterbox = "true";
                    break;
                case CampaignType.hosting:
                    this.html = '';
                    this.javascript = '';
                    this.css = '';
                    break;
                case CampaignType.desktop_html_interscroll:
                    this.relativeHeight = RelativeHeightEnum['80%'];
                    this.interactionEnabled = "false";
                    break;
                case CampaignType.video_desktop_interscroll:
                    this.relativeHeight = RelativeHeightEnum['80%'];
                    this.interactionEnabled = "false";
                    this.letterbox = "true";
                    break;
                case CampaignType.fullpage_overlay_mobile_html:
                case CampaignType.fullpage_overlay_desktop_html:
                    this.interactionEnabled = "false";
            }

            switch (type) {
                case CampaignType.video_topscroll:
                case CampaignType.topscroll_desktop_video:
                case CampaignType.vertical_video_interscroll:
                case CampaignType.video_desktop_interscroll:
                case CampaignType.video_skin:
                case CampaignType.video_banner_template:
                    this.interactionEnabled = "true";
                    break;
            }
        }
    }
}

export enum TopscrollHeightEnum {
    '80%' = '80vh',
    '100%' = '100vh'
}

export enum RelativeHeightEnum {
    '50%' = '50vh',
    '80%' = '80vh',
    '100%' = '100vh'
}